import React from "react";
import FaqSection from "./../components/FaqSection";
import CtaSection from "./../components/CtaSection";
import { useRouter } from "./../util/router.js";

function FaqPage(props) {
  const router = useRouter();

  return (
    <>
      <FaqSection
        color="white"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Frequently Asked Questions"
        subtitle=""
      ></FaqSection>
      <CtaSection
        color="primary"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Want to get involved and help crowdsource?"
        buttonText="SIGN UP"
        buttonOnClick={() => {
          window.location.replace(
            "https://covidcrowdsource.typeform.com/to/c1ev2R"
          );

          global.window.location.href =
            "https://covidcrowdsource.typeform.com/to/c1ev2R";        }}
      ></CtaSection>
    </>
  );
}

export default FaqPage;
